import { getNoBidClientStyle } from 'utils/helpers'
import s from './CompaniesCellRenderer.scss'
import { Link } from 'react-router-dom'

const AwardedToCellRenderer = ({ data }) => {
  if (!data) return null
  const { awarded_company_id, awarded_company_name, client_isNoBid } = data

  return (
    <Link
      className={s.link}
      style={getNoBidClientStyle(client_isNoBid)}
      to={`/companies/${awarded_company_id}`}
    >
      {awarded_company_name}
    </Link>
  )
}

export default AwardedToCellRenderer
